<template>
  <narrow-container>
    <h1 class="headline-secondary text--center">
      {{ $i18n.t('TOPUP_MPAY_SUCCESS.HEADER') }}
    </h1>
    <br>
    <p class="text--center">
      {{ $i18n.t('TOPUP_MPAY_SUCCESS.P1') }}
    </p>
    <p class="text--center">
      {{ $i18n.t('TOPUP_MPAY_SUCCESS.P2') }}
    </p>
    <div class="block--centered">
      <router-link
        class="button button--blue button--centered"
        :to="{name:'topUp'}"
      >
        {{ $i18n.t('TOPUP_MPAY_SUCCESS.ATU_BUTTON') }}
      </router-link>
    </div>
    <br>
    <p class="text--center">
      {{ $i18n.t('TOPUP_MPAY_SUCCESS.P3') }}
    </p>
  </narrow-container>
</template>

<script>
  export default {
    name: "TopupMpaySuccess",
    components: {},
    mounted: function () {
      let price = '';
      if(this.$store.state.lastTopupValue) {
        price = ' '+this.$store.state.lastTopupValue+' EUR';
      }
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Success'+price, value: this.$store.state.lastTopupValue, noninteraction: false });
      this.$store.commit("clearLastTopupValue");
    }
  }
</script>

<style scoped lang="scss">
  .button--centered {
    padding-right: 62px;
    padding-left: 62px;
  }
  .block--centered {
    text-align: center;
  }
</style>
